/**
 * Each name has a matching `public/icons/<name>.*` file and a `--icon` rule in
 * contact.css. Adding one means adding all three.
 */
export type SocialIcon = 'github' | 'linkedin' | 'instagram' | 'vrmln';

export type SocialLink = {
  /** Not rendered — it is the link's accessible name behind the icon. */
  readonly label: string;
  readonly url: string;
  readonly icon: SocialIcon;
};

export type SiteMetadata = {
  readonly title: string;
  readonly tagline: string;
  readonly ownerName: string;
  /** Formspree form endpoint. Doubles as the `<form action>` no-JS fallback. */
  readonly contactFormEndpoint: string;
  readonly social: readonly SocialLink[];
};

export const site: SiteMetadata = {
  title: 'IEDLabs',
  tagline: 'Interactive Design and Digital Dark Arts',
  ownerName: 'Jason Araujo',
  contactFormEndpoint: 'https://formspree.io/f/mqpzzwro',
  social: [
    { label: 'GitHub', url: 'https://github.com/zombience', icon: 'github' },
    { label: 'LinkedIn', url: 'https://linkedin.com/in/jasonaraujo', icon: 'linkedin' },
    { label: 'Instagram', url: 'https://www.instagram.com/azurient', icon: 'instagram' },
    { label: 'VRMLN', url: 'https://vrmln.co', icon: 'vrmln' },
  ],
};
